import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=5670c2ab&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=5670c2ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670c2ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5670c2ab')) {
      api.createRecord('5670c2ab', component.options)
    } else {
      api.reload('5670c2ab', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=5670c2ab&scoped=true&", function () {
      api.rerender('5670c2ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QzbTU8pD2gYL/JS/comp/DateRangeExt.vue"
export default component.exports